// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"UpgradedPagination_paginationContainer__dd-NA"};